/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Registry_AllInputs */

const id_tld_pricing_registry_all = /** @type {(inputs: Tld_Pricing_Registry_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua registry`)
};

const en_tld_pricing_registry_all = /** @type {(inputs: Tld_Pricing_Registry_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All registries`)
};

/**
* | output |
* | --- |
* | "All registries" |
*
* @param {Tld_Pricing_Registry_AllInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_registry_all = /** @type {((inputs?: Tld_Pricing_Registry_AllInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Registry_AllInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_registry_all(inputs)
	return id_tld_pricing_registry_all(inputs)
});